import React, { FC } from 'react';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core';
import { ReactComponent as XDeleteIcon } from 'img/icons/x-bold_deprecated.svg';
import { ReactComponent as CheckIcon } from 'img/icons/check.svg';
import menuItems from 'common/messages/menuItems';
import ActionItem from 'common/components/ActionsMenu/ActionItem';

const useStyles = makeStyles({
  icon: {
    width: 16,
    height: 16,
  },
});

interface IActionItemChangeStatus {
  key?: string;
  active: boolean;
  onClick: () => void;
  disabled?: boolean;
}

const ActionItemChangeStatus: FC<IActionItemChangeStatus> = ({
  key = 'change-status',
  active,
  onClick,
  disabled = false,
}) => {
  const classes = useStyles();
  const intl = useIntl();
  let icon: JSX.Element;
  let message: string;

  if (active) {
    icon = <XDeleteIcon className={classes.icon} />;
    message = intl.formatMessage(menuItems.deactivate);
  } else {
    icon = <CheckIcon className={classes.icon} />;
    message = intl.formatMessage(menuItems.activate);
  }

  return (
    <ActionItem key={key} icon={icon} onClick={onClick} disabled={disabled}>
      {message}
    </ActionItem>
  );
};

export default ActionItemChangeStatus;
